<div class="input input-switch"
  [ngClass]="'label-' + labelPosition"
  [class.error]="error"
  [class.disabled]="disabled"
  [class.full-width]="fullWidth">
  <div class="switch-row">
    @if (label) {
      <label [attr.for]="id" class="switch-text-label">
        {{ label }}{{ required ? '*' : '' }}
      </label>
    }
    <label class="switch-toggle">
      <input
        type="checkbox"
        class="switch-input"
        [attr.id]="id"
        [attr.name]="name"
        [disabled]="disabled"
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        [required]="required"
        (input)="inputEvent.emit($event)"
        (blur)="onBlur($event)"
        (focus)="focusEvent.emit($event)"
        (keydown)="keyDownEvent.emit($event)"
        (keyup)="keyUpEvent.emit($event)">
      <span class="switch-track" [class.on]="value">
        <span class="switch-thumb"></span>
      </span>
    </label>
  </div>
  @if (showMessages) {
    <div class="messages">
      @for (error of errorMessages; track error) {
        <small class="error">{{ error }}</small>
      }
      <ng-content></ng-content>
    </div>
  }
</div>
